import { useTranslation } from 'react-i18next';
import { backdropClose } from '../lib/modalBackdrop';

interface Props {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  /** Текст кнопки подтверждения — по умолчанию «Удалить» (исходный смысл компонента), но для
   *  не-удаляющих деструктивных действий (сброс 2FA, выключение фичи) нужен другой глагол. */
  confirmLabel?: string;
}

export default function ConfirmModal({ message, onConfirm, onCancel, confirmLabel }: Props) {
  const { t } = useTranslation('dialogs');
  return (
    <div className="modal-backdrop" {...backdropClose(onCancel)}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 360 }}>
        <p style={{ marginBottom: 16, fontSize: 15 }}>{message}</p>
        <div className="row" style={{ justifyContent: 'flex-end' }}>
          <button className="btn btn-ghost" onClick={onCancel}>{t('actions.cancel')}</button>
          <button
            className="btn"
            style={{ background: 'var(--error)' }}
            onClick={onConfirm}
          >
            {confirmLabel ?? t('actions.delete')}
          </button>
        </div>
      </div>
    </div>
  );
}
